import type { CONSTANTS } from "@/@types/CONSTANTS";

declare global {
  var CONSTANTS: CONSTANTS;

  interface Window {
    CONSTANTS: CONSTANTS;
  }
}

globalThis.CONSTANTS = {
  IMPORT_EXPORT_VERSION: 8,
  WEB_TYPE: "Testa",
  IS_WEB_WORKER: false,
  LOCAL_MODE: import.meta.env.LOCAL_MODE == "true",
  IS_PROD_ENV: import.meta.MODE == "production",
  IS_DEV_ENV: import.meta.MODE == "development",
  IS_TEST_ENV: import.meta.MODE == "test",
};

import("@/helpers/events/domContentLoaded").then(({ suspendDomContentLoaded }) => {
  suspendDomContentLoaded(
    (async () => {
      // import("./shared/init-shared-worker");
      await import("./testa/index");
    })()
  );
});
